import SEO from '../components/SEO';

export default function PressReleasePage() {
  return (
    <div className="flex-1 bg-white py-12">
      <SEO
        title="Press Release | Waybook"
        description="Latest news and press releases from Waybook. Read about our launch, features, and vision for the future of travel planning."
        keywords="press release, news, announcements, media, travel tech startup"
        canonicalUrl="https://www.waybook.me/press-release"
        structuredData={[
          {
            '@context': 'https://schema.org',
            '@type': 'NewsArticle',
            headline: 'Waybook Announces Launch of Travel Sharing Platform in 2026',
            datePublished: '2025-12-27',
            author: {
              '@type': 'Organization',
              name: 'Waybook'
            },
            publisher: {
              '@type': 'Organization',
              name: 'Waybook',
              logo: {
                '@type': 'ImageObject',
                url: 'https://www.waybook.me/waybook-logo.png'
              }
            },
            description: 'Waybook announces the upcoming launch of its innovative travel planning and emotion-sharing application in 2026'
          }
        ]}
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold mb-8">Press Release</h1>
        
        <div className="prose max-w-none space-y-8">
          <article className="border-b border-gray-200 pb-8">
            <div className="text-sm text-gray-500 mb-2">December 27, 2025</div>
            <h2 className="text-2xl font-bold mb-4">
              Waybook Announces Launch of Travel Sharing Platform in 2026
            </h2>
            <p className="text-gray-700 mb-4">
              Waybook, a new travel technology startup, officially announces 
              the upcoming launch of its innovative travel planning and emotion-sharing application in 2026. 
              The platform will revolutionize how travelers plan their journeys and share their experiences with 
              friends and family across the globe.
            </p>
            <p className="text-gray-700 mb-4">
              Waybook is being developed in Warsaw by two lead developers: <strong>Mikita Kutsur</strong> and <strong>Andrei Babrounik</strong>. The startup focuses on creating an intuitive, user-centric application that combines intelligent travel planning 
              tools with social features for sharing travel moments and emotions.
            </p>
            <p className="text-gray-700 mb-4">
              <strong>"We're creating a platform that brings travelers closer together,"</strong> said the Waybook team. 
              <strong> "Whether you're planning a solo adventure or coordinating a group trip, Waybook makes it easy to 
              organize every detail and capture the emotions that make travel unforgettable. We believe travel is not just 
              about destinations—it's about the connections and memories we create."</strong>
            </p>
            <p className="text-gray-700 mb-4">
              <strong>Key features of Waybook include:</strong>
            </p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
              <li>Intelligent trip planning with customizable itineraries</li>
              <li>Collaborative planning tools for group travel coordination</li>
              <li>Emotion and memory sharing features to capture the travel experience</li>
              <li>Smart recommendations based on travel preferences and interests</li>
              <li>Real-time updates and seamless integration with travel booking services</li>
              <li>Interactive maps and location-based travel insights</li>
            </ul>
            <p className="text-gray-700 mb-4">
              The development team is currently in the final stages of building the MVP and is preparing for a full 
              public launch in 2026. Early access opportunities and beta testing programs will be announced in the coming months.
            </p>
            <p className="text-gray-700">
              "We're excited to bring Waybook to the global travel community and help people create meaningful travel 
              experiences," the team added. "Stay tuned for more updates as we approach our 2026 launch."
            </p>
          </article>

          <section className="mt-12 p-6 bg-gray-50 border border-gray-200">
            <h3 className="text-lg font-semibold mb-2">About Waybook</h3>
            <p className="text-gray-700 mb-4">
              Waybook is a travel planning and emotion-sharing platform developed in Warsaw, Poland. Our mission is to 
              make travel planning effortless and help travelers share their experiences and emotions with their communities. 
              Founded by Mikita Kutsur and Andrei Babrounik, Waybook is set to launch in 2026.
            </p>
            <h3 className="text-lg font-semibold mb-2 mt-6">Media Contact</h3>
            <p className="text-gray-700">
              For press inquiries, interviews, or more information, please contact:<br />
              Email: press@waybook.me<br />
              Location: Warsaw, Poland
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
